// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block-wrapper{position:relative;width:100%;padding-top:32px;padding-bottom:32px}@media(min-width:640px){.block-wrapper{padding-top:calc(4vw + 6.4px);padding-bottom:calc(4vw + 6.4px)}}@media(min-width:1440px){.block-wrapper{padding-top:64px;padding-bottom:64px}}[data-colored=false]+[data-colored=false] .block-wrapper{padding-top:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
